import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import ComprehensiveHero from "./ComprehensiveHero";
import RiskMitigation from "./RiskMitigation";
import CodeReview from "./CodeReview";

function SmartContractAudit() {
  return (
    <div>
      <Header />
      <ComprehensiveHero />
      <RiskMitigation />
      <CodeReview />
      <Footer />
    </div>
  );
}

export default SmartContractAudit;
